import { ObservableMap } from 'mobx';
import { createStore } from 'satcheljs';
import type { OwaSessionStore } from './schema/OwaSessionStore';

const initialStore: OwaSessionStore = {
    accountScopeUserSettingsMap: new ObservableMap({}),
    userConfiguration: {},

    connectedAccountsUserConfigurationMap: new ObservableMap({}),
    defaultFolderNameToIdMap: new ObservableMap({}),
    defaultFolderIdToNameMap: new ObservableMap({}),
};

export const getStore: () => OwaSessionStore = createStore<OwaSessionStore>(
    'owaSessionStore',
    initialStore
);

const store = getStore();
export default store;
